<template>
  <div class="doc-section">
    <span class="type-title">
      文档
      <i>
        (共
        <em>{{ length }}</em> 条记录)
      </i>
      <look-more v-if="hideContent && alloverflow" type="document" />
    </span>
    <div :class="{ 'data-view': true, 'view-over': !hideContent }">
      <div v-for="(section, index) in currentData" :key="index">
        <p v-if="section.items.length > 0">
          <span
            :class="{
              'section-title': true,
              'bg-helpdesk': section.title === 'helpdesk',
              'bg-rules': section.title === '云杉制度'
            }"
          >{{ section.title }}</span>
          <i class="record-length">
            (共
            <em>{{ parseInt(lengthMap[section.title] || 0) }}</em> 条记录)
          </i>
          <look-more v-if="hideContent && section.items.length > max" :type="section.title" />
        </p>
        <a
          v-for="(i, n) in hideContent
            ? section.items.slice(0, max)
            : section.items"
          :key="n"
          class="result-item"
          :href="i.url"
          target="_blank"
        >
          <span v-high-light="{ key: $route.params.key, content: i.title }">
            {{
            i.title
            }}
          </span>
          <p
            class="content"
            v-if="section.title === 'helpdesk'"
            v-high-light="{ key: $route.params.key, content: i.type==2?md.render(i.content):i.content }"
          ></p>
        </a>
      </div>
    </div>

    <el-pagination
      v-if="!hideContent"
      :total="length"
      layout="prev, pager, next"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import lookMore from "./look-more";
import mixinsPagination from "@/mixins/pagination";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt();

export default {
  name: "doc-section",
  mixins: [mixinsPagination],
  components: { lookMore },
  props: {
    sectionData: Array,
    hideContent: {
      // 是否隐藏部分内容，不隐藏时要分页展示
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 3
    }
  },

  computed: {
    activeSectionData: function() {
      const { type } = this.$route.params;
      // 点击查看全部时按照类型过滤数据
      return this.sectionData.filter(item =>
        type && type !== "document" ? item.title == type : true
      );
    }
  },
  created() {
    console.log(this.md);
  },

  data() {
    return {
      pageSize: 7,
      md
    };
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.doc-section {
  .data-view {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    padding: 20px 20px 0;
    border: 1px solid rgba(237, 237, 237, 1);
  }
  .section-title {
    color: #ffffff;
    width: 80px;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
  }
  .bg-helpdesk {
    background-image: linear-gradient(to right, #50b2ff, #507bff);
  }

  .bg-rules {
    background-color: #00bf93;
  }

  .record-length {
    color: rgba(143, 149, 172, 1);
    font-size: 12px;
    font-weight: normal;
    margin-left: 6px;
  }

  .result-item {
    margin: 30px 0;
    span {
      display: block;
    }
    .content {
      line-height: 18px;
      color: #666666;
      font-size: 14px;
      margin-top: 10px;
      white-space: pre-wrap;
      word-break: break-all;
      display: inline-block;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      max-height: 36px;
    }
  }
}
</style>
